import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Button from "@mui/material/Button";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Icon from "@shared/components/Icon";
const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});
const ContactFormAttachments = ({ mailAllowedAttachmentType, filesForm, showError, onUploadFile, onRemoveFile, }) => {
    const hasMultipleAttachmentTypes = mailAllowedAttachmentType &&
        mailAllowedAttachmentType.split(",").length > 1;
    return (_jsxs(Stack, { spacing: 1, sx: { minWidth: 0 }, children: [_jsxs(Button, { component: "label", variant: "outlined", color: "secondary", size: "small", startIcon: _jsx(Icon, { icon: "paperclip" }), sx: {
                    width: "fit-content",
                    maxWidth: "100%",
                    minWidth: 0,
                    whiteSpace: "normal",
                    textAlign: "left",
                    "& .MuiButton-startIcon": { flexShrink: 0 },
                }, children: [_jsx("span", { style: { minWidth: 0, overflowWrap: "anywhere" }, children: `Ajouter une pièce jointe ${mailAllowedAttachmentType
                            ? `(format${hasMultipleAttachmentTypes ? "s" : ""} accepté${hasMultipleAttachmentTypes ? "s" : ""} : ` +
                                `${mailAllowedAttachmentType.split(",").join(", ")})`
                            : ""}` }), _jsx(VisuallyHiddenInput, { accept: mailAllowedAttachmentType, id: "input-file-attachment", type: "file", style: { display: "none" }, onChange: onUploadFile, spellCheck: false, "aria-label": "T\u00E9l\u00E9charger des pi\u00E8ces jointes" })] }), Array.isArray(filesForm) &&
                filesForm.map((fileForm, index) => {
                    return (fileForm.name && (_jsxs(FormHelperText, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Icon, { icon: "paperclip", title: "Pi\u00E8ce jointe" }), _jsx("span", { children: fileForm.name }), _jsx(IconButton, { size: "small", onClick: () => onRemoveFile(fileForm.name), title: `Supprimer la pièce jointe ${fileForm.name}`, children: _jsx(Icon, { icon: "times" }) })] }, fileForm.name + index)));
                }), showError("fileForm") && (_jsxs(FormHelperText, { error: true, id: "fileForm-error", role: "alert", children: [_jsx(Icon, { icon: "exclamation-circle", title: "Erreur" }), "\u00A0La taille des pi\u00E8ces jointes d\u00E9passe la taille maximale autoris\u00E9e."] }))] }));
};
export default ContactFormAttachments;
